export default "__VITE_ASSET__Bkp2O$Q3__"